import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import TextField from 'react-mui-lib/form-widgets/TextField';
import Checkbox from 'react-mui-lib/form-widgets/Checkbox';
import RadioList from 'react-mui-lib/form-widgets/RadioList';

import registry from 'react-mui-lib/registry';
import { has_superaccess } from '../utils';


export default class NotificationDialog extends React.Component {
    open(game = null) {
        const c = this;

        const prevGame = c.state.game;
        const gameChanged = prevGame ? (game ? prevGame.id !== game.id : true) : !!game;
        const gameName = game ? game.name : c.game_controller.getModel('name').getModelValue();

        if (gameChanged || !c.state.editing) {
            c.controller.editNew({
                title: gameName,
                message: '',
                filter: 'PARTICIPANTS',
                play_sound: false
            });
        }

        c.setState({
            dialog_open: true,
            editing: true,
            game: game
        });
    }

    constructor(props) {
        super(props);

        this.controller = registry.get('game_notifications_form_controller');
        this.game_controller = registry.get('game_form_controller');
        this.store = registry.get('store');

        this.state = {
            dialog_open: false,
            editing: false,
            game: null
        };
    }

    componentDidMount() {
        const c = this;
        c.unsubscribe = c.store.subscribe(() => {
            if (c.state.dialog_open) {
                c.setState({});
            }
        });
    }

    componentWillUnmount() {
        const c = this;
        if (c.unsubscribe) {
            c.unsubscribe();
        }
    }

    render() {
        const c = this;

        const filter_options = [
            {val: 'ALL', label: 'Всем'},
            {val: 'PARTICIPANTS', label: 'Участникам игры'},
            {val: 'EXCEPT-PARTICIPANTS', label: 'Всем, кроме участников игры'}
        ];

        return <Dialog fullWidth={true}
                       open={c.state.dialog_open}
                       onClose={() => c.setState({dialog_open: false})}>
            <DialogTitle>
                Отправить сообщения со ссылкой на игру
            </DialogTitle>
            <DialogContent>
                {!c.isLimitedAuthor() && (
                    <TextField path="title"
                               label="Заголовок" />
                )}
                <TextField path="message"
                           multiLine={true}
                           label="Сообщение"
                           inputProps={{ maxLength: 250 }} />
                {!c.isLimitedAuthor() && (
                    <RadioList path="filter"
                               label="Кому отправить"
                               options={filter_options} />
                )}
                <Checkbox path="play_sound"
                          label="звук" />
            </DialogContent>
            <DialogActions>
                <Button variant="raised"
                        color="primary"
                        onClick={c.onSubmit.bind(c)}>
                    Отправить
                </Button>
                <Button color="primary"
                        onClick={() => c.setState({dialog_open: false})} >
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>;
    }

    getChildContext() {
        const c = this;

        return {
            controller: c.controller
        };
    }

    isLimitedAuthor() {
        return !has_superaccess();
    }

    onSubmit() {
        const c = this;

        const gameId = c.state.game ? c.state.game.id : c.game_controller.state.entity_id;
        if (!gameId) return;

        if (!c.controller.sendMessages(gameId)) return;

        c.setState({
            dialog_open: false,
            editing: false,
            game: null
        });
    }
}

NotificationDialog.childContextTypes = {
    controller: PropTypes.object
};
